import React from "react";
import { Tabs } from "antd";
import styled from "@emotion/styled";

const TabsContainer = styled(Tabs)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontSize: "1.6rem",
  fontFamily: "Pretendard",

  ".ant-tabs-nav": {
    width: "100%",

    // ":before": {
    //   border: underline ? "" : "none",
    // },

    // ".ant-tabs-ink-bar": {
    //   backgroundColor: underline ? theme.color.black : "transparent",
    // },
  },

  ".ant-tabs-nav-list": {
    flex: 1,
  },

  ".ant-tabs-nav-wrap": {
    padding: "0 2rem",
    width: "100%",
  },

  ".ant-tabs-tab": {
    flex: 1,
    outline: "none",
    display: "flex",
    justifyContent: "center",
    color: theme.color.black,
    fontSize: "1.6rem",
    fontWeight: theme.fontWeight.medium,
    margin: "0 !important",
  },

  ".ant-tabs-tab-active": {
    backgroundColor: "rgba(17, 17, 17, 0.05)",
  },

  ".ant-tabs-tab-btn": {
    color: theme.color.light_gray, // 액티브 아닐때 텍스트 색상
  },

  ".ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn": {
    color: theme.color.black, // 액티브일때 텍스트 색상
  },

  // 탭 보더 아래선 스타일
  ".ant-tabs-ink-bar": {
    backgroundColor: theme.color.black,
    border: "1px solid ",
  },

  ".ant-tabs-content-holder": {
    width: "100%",
  },
}));

const TabWithPanel = ({
  item,
  underline = false,
  defaultValue = "1",
  onChange,
}: {
  item: any;
  underline?: boolean;
  defaultValue?: string;
  onChange?: ((key: string) => void) | undefined;
}) => {
  if (item.length === 1) {
    return <div>{item[0].children}</div>;
  }

  return (
    <TabsContainer
      defaultActiveKey={defaultValue ? defaultValue : "1"}
      tabPosition="top"
      onChange={onChange}
      items={item.map((item: any) => {
        return {
          label: item.label,
          key: item.key,
          disabled: item.disabled,
          children: item.children,
        };
      })}
      // underline={underline}
    />
  );
};

export default TabWithPanel;
